import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './app/App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import packageJson from '../package.json';

import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

import momentj from 'moment-jalaali';
momentj.loadPersian({ dialect: "persian-modern" })

const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.0/8 are considered localhost for IPv4.
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

if (!isLocalhost) {
    Sentry.init({
        dsn: "https://b9e69505ba6c4d548ebd35e9b540e659@sentry.hin4v4.ir/9",
        // autoSessionTracking: false, // probably, it is not supported in the server
        integrations: [new Integrations.BrowserTracing()],
        environment: packageJson.serverName,
        release: packageJson.version,
    
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: (packageJson.serverName === "staging") ? 0.5 : 0.2,
    });
}

console.log(packageJson.version, packageJson.serverName)

console.log("initializing serviceWorkerConfigRef")
let serviceWorkerConfigRef = {}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <React.StrictMode>
            <App serviceWorkerConfigRef={serviceWorkerConfigRef} />
        </React.StrictMode>
    </BrowserRouter>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register({
    onUpdate: (registration) => {
        if (serviceWorkerConfigRef.onUpdate) {
            serviceWorkerConfigRef.onUpdate(registration)
        }
    },
    onGotRegistration: (registration) => {
        if (serviceWorkerConfigRef.onGotRegistration) {
            serviceWorkerConfigRef.onGotRegistration(registration)
        }
    },
    onChangeState: (state) => {
        if (serviceWorkerConfigRef.onChangeState) {
            serviceWorkerConfigRef.onChangeState(state)
        }
    },
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();